export default __webpack_public_path__ + "static/media/3.d4cc499d.webp";